var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgotPassConfirm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Forgot_Password_Confirmation",
    "data-name": "Forgot Password Confirmation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.208,
    height: 102.208,
    viewBox: "0 0 102.208 102.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_834",
    "data-name": "Ellipse 834",
    cx: 51.043,
    cy: 51.043,
    r: 51.043,
    fill: "#da291c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M153.613,147.466H89.682l23.16,24.116,6.683,6.767c-3.636-.831-3.861-1.349-5.473-2.665-.845-.69-2.478-2.566-4.958-5.1l-20.878-21.32v39.69l1.65,1.65-.185.192,29.369,29.369q1.321.068,2.659.068a51.1,51.1,0,0,0,51.1-51.1q0-1.271-.062-2.527Z",
    transform: "translate(-70.607 -118.028)",
    fill: "#ad1409"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11878",
    "data-name": "Group 11878",
    transform: "translate(17.61 29.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M88.217,156.484v39.69l19.355-19.925Z",
    transform: "translate(-88.217 -154.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M346.566,156.484v39.69l-19.259-19.845Z",
    transform: "translate(-279.579 -154.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M95.558,147.466h63.931l-25.126,26.162a9.483,9.483,0,0,1-13.679,0Z",
    transform: "translate(-94.093 -147.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M135.813,267.7a11.492,11.492,0,0,1-16.578,0l-4.262-4.438L95.558,283.482h63.931l-19.415-20.215Z",
    transform: "translate(-94.093 -240.15)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassConfirm);
export default __webpack_public_path__ + "static/media/forgot_pass_confirm.92ad76d90d36442241bf93b202cb8e7b.svg";
export { ForwardRef as ReactComponent };